import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

export const POSITION_QUALITIES = [
    'Passionate software engineer.',
    'Strives for high-quality, well tested code.',
    'Always looking for new, innovative, and/or better ways of approaching and implementing software.',
    'An accountable team player who respects fellow team members.',
    'Someone who is not afraid to lead and always willing to collaborate.',
    'Aiming to become a better technologist.',
    'A problem solver.'
];

export const JOB_POSITIONS = [
    {
        icon: <i className="icon-java-bold text-info mr-2"/>,
        title: 'Senior-Level Full-Stack Java Developer',
        location: 'Northern VA',
        qualifications: [
            '6 years or more of experience developing Java (Spring) web applications.',
            <span>Must be an <b>US Citizen</b>.</span>,
            <span><b>Must have or be able to obtain, and maintain a government issued <u>Top Secret SCI clearance with full-scope polygraph</u>.</b></span>,
            '4 year college degree in Computer Science or related engineering field is preferred.',
            'Experience in agile software development. Primarily with Scrum and Kanban.',
            'Strong database skills with MySQL, PostgreSQL, Oracle, etc.',
            'Gradle and/or Maven experience is a must.',
            'Deep commitment to test driven development (TDD) using frameworks such as JUnit.',
            'Strong software development experience with object-oriented design.',
            'Experience developing and integrating with web services using REST and/or SOAP (WSDL).',
            'Web development experience using HTML, CSS, and JavaScript. Experience with using web development technologies and frameworks, such as: Webpack, React, SCSS, AngularJS, Node, Babel, etc., is a plus.',
            'Experience with CI tools such as Jenkins.',
            'Experience with big data processing technologies such as Hadoop (MapReduce and HDFS), Spark, Accumulo, and HBase.',
            'Experience with container and orchestration technologies such as Puppet, Vagrant, and Docker.'
        ]
    },
    {
        icon: <i className="icon-ruby text-danger mr-2"/>,
        title: 'Mid-Level Full-Stack Ruby Developer',
        location: 'Northern VA',
        qualifications: [
            '2-5 years of experience developing Ruby (Rails) web applications.',
            <span>Must be an <b>US Citizen</b>.</span>,
            <span><b>Must be able to at least obtain and maintain a government issued <u>Public Trust</u> clearance.</b></span>,
            '4 year college degree in Computer Science or related engineering field is preferred.',
            'Experience in agile software development. Primarily with Scrum and Kanban.',
            'Strong database skills with MySQL, PostgreSQL, Oracle, etc.',
            'Deep commitment to test driven development (TDD) using frameworks such as RSpec, Cucumber, MiniTest, etc.',
            'Strong software development experience with object-oriented design.',
            'Experience developing and integrating with web services using REST and/or SOAP (WSDL).',
            'Web development experience using HTML, CSS, and JavaScript. Experience with using web development technologies and frameworks, such as: Webpack, React, SCSS, AngularJS, Node, Babel, etc., is a plus.'
        ]
    },
    {
        icon: <i className="icon-ruby text-danger mr-2"/>,
        title: 'Senior-Level Full-Stack Ruby Developer',
        location: 'Northern VA',
        qualifications: [
            '6 years or more of experience developing Ruby (Rails) web applications.',
            <span>Must be an <b>US Citizen</b>.</span>,
            <span><b>Must be able to at least obtain and maintain a government issued <u>Public Trust</u> clearance.</b></span>,
            '4 year college degree in Computer Science or related engineering field is preferred.',
            'Experience in agile software development. Primarily with Scrum and Kanban.',
            'Strong database skills with MySQL, PostgreSQL, Oracle, etc.',
            'Deep commitment to test driven development (TDD) using frameworks such as RSpec, Cucumber, MiniTest, etc.',
            'Strong software development experience with object-oriented design.',
            'Experience developing and integrating with web services using REST and/or SOAP (WSDL).',
            'Web development experience using HTML, CSS, and JavaScript. Experience with using web development technologies and frameworks, such as: Webpack, React, SCSS, AngularJS, Node, Babel, etc., is a plus.',
            'Experience with CI tools such as Jenkins.',
            'Experience working with Amazon Web Services.',
            'Experience with container and orchestration technologies such as Puppet, Vagrant, and Docker.'
        ]
    },
    {
        icon: <i className="icon-java-bold text-info mr-2"/>,
        title: 'Senior-Level Full-Stack Java Developer',
        location: 'Northern VA',
        qualifications: [
            '6 years or more of experience developing Java (Spring) web applications.',
            <span>Must be an <b>US Citizen</b>.</span>,
            <span><b>Must be able to at least obtain and maintain a government issued <u>Public Trust</u> clearance.</b></span>,
            '4 year college degree in Computer Science or related engineering field is preferred.',
            'Experience in agile software development. Primarily with Scrum and Kanban.',
            'Strong database skills with MySQL, PostgreSQL, Oracle, etc.',
            'Gradle and/or Maven experience is a must.',
            'Deep commitment to test driven development (TDD) using frameworks such as JUnit.',
            'Strong software development experience with object-oriented design.',
            'Experience developing and integrating with web services using REST and/or SOAP (WSDL).',
            'Web development experience using HTML, CSS, and JavaScript. Experience with using web development technologies and frameworks, such as: Webpack, React, SCSS, AngularJS, Node, Babel, etc., is a plus.',
            'Experience with CI tools such as Jenkins.',
            'Experience working with Amazon Web Services.',
            'Experience with container and orchestration technologies such as Puppet, Vagrant, and Docker.'
        ]
    },
    {
        icon: <FontAwesomeIcon className="text-primary mr-2" icon={["fab", "docker"]}/>,
        title: 'DevOps Automation Engineer',
        location: 'Northern VA',
        qualifications: [
            '3 or more years experience developing/configuring integration environments and pipelines for full stack Java, Ruby, and JavaScript web applications.',
            <span>Must be an <b>US Citizen</b>.</span>,
            <span><b>Must be able to at least obtain and maintain a government issued <u>Public Trust clearance</u>.</b></span>,
            '4 year college degree in Computer Science or related engineering field is preferred.',
            'AWS Professional or Associate Certification.',
            'Experience in agile software development. Primarily with Scrum and Kanban.',
            'Experience with continuous integration tools such as Jenkins.',
            'Understanding of how to build pipelines to achieve continuous delivery/deployment.',
            'Experience in scripting using Bash (Shell), Ruby, Groovy, etc.'
        ]
    }
];


// WEBPACK FOOTER //
// ./src/js/App/JoinUs/JobPositions.js